import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, CardTitle, Row, Col, Button, Badge, Input, FormGroup, Label } from 'reactstrap';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import PMCreateTasksService from '../../../../../../../Service/OPSServices/ProactiveMonitoringServices/PMCreateTasksService';
import DisplayObject from './DisplayObject';

function ProactiveMonitoringTasks(props) {
  const [selectedAlerts, setSelectedAlerts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [actionRequiredRows, setActionRequiredRows] = useState({});

  const handleActionRequiredToggle = (rowId) => {
    setActionRequiredRows(prev => ({
      ...prev,
      [rowId]: prev[rowId] === "Action Required" ? null : "Action Required"
    }));
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };
  const filteredData = props.tasksData.filter((item) =>
    Object.values(item).join(' ').toLowerCase().includes(searchText.toLowerCase()));


  const handleSelectAlert = (row) => {
    const rowId = row.id;
    console.log(row);

    setSelectedAlerts(prev => {
      if (prev.includes(rowId)) {
        return prev.filter(id => id !== rowId);
      } else {
        return [...prev, rowId];
      }
    });
  };
  const formatValue = (value) => {
    if (!value || value === "N/A") return "N/A";

    try {
      const obj = JSON.parse(value);
      return `Review id: ${obj.review_id}<br/>Score: ${obj.score}<br/>Votes: ${obj.votes}`;
    } catch (err) {
      return value;
    }
  };

  const handleCreateBulkTasks = (e) => {
    e.preventDefault();
    const selectedData = props.tasksData && props.tasksData.filter(row => selectedAlerts.includes(row.id));
    setLoading(true);
    const requestData = 
      selectedData.map((alert, index) => {
        const finalAssignedTo = alert.assigned_to || props.loggedInUserId || "";

        return {
          id: alert.id,
          type: alert.type,
          asin: alert.asin,
          taskTitle: 'Task from Alert',
          integerid: alert.integerid,
          storeName: alert.store_name,
          oldValue: formatValue(alert.old_value),
          newValue: formatValue(alert.new_value),
          changeType: alert.type,
          // assignedto: finalAssignedTo,
            activeTab: props.activeTab || 'all'
        };
      })
    
    

    PMCreateTasksService(props.token, requestData).then((response) => {
        if (response) {
          console.log(response)
          window.location.reload();
        }

        setLoading(false);
      })
     
  }

  const columns = [
    ...(props.activeTab === "complete"
      ? [
          {
            Header: "Destination Id",
            accessor: "destinationid",
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                <p
                  title={cellInfo.value}
                  className="m-0"
                >
                  {cellInfo.value}
                </p>
              </div>
            ),
          },
        ]
      : []),
    ...(props.activeTab !== "complete"
      ? [
        {
          Header: "Select",
          accessor: "type",
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-center w-100">
              <input
                checked={selectedAlerts.includes(cellInfo.original.id)}
                disabled={cellInfo.original.status === "Created"}
                onClick={() => handleSelectAlert(cellInfo.original)}
                type='checkbox'
              />
            </div>
          ),
          width: 65,
        },
      ]
      : []),
    {
      Header: "Store Name",
      accessor: "store_name",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center ml-1 w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
    // {
    //   Header: "IntegerId",
    //   accessor: "integerid",
    //   Cell: (cellInfo) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
    //     </div>
    //   ),
    // },
    {
      Header: "Asin",
      accessor: "asin",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Type",
      accessor: "type",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Old Value",
      accessor: "old_value",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table"><DisplayObject data={cellInfo.value} /></p>
        </div>
      ),
    },
    {
      Header: "New Value",
      accessor: "new_value",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table"><DisplayObject data={cellInfo.value} /></p>
        </div>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
    },
    //  {
    //   Header: "Assigned To",
    //   accessor: "assigned_to",
    //   Cell: (cellInfo) => {
    //     const { original, value, index } = cellInfo; 

    //     return (
    //       <select
    //         className="form-control w-75"
    //         name="assignedto"
    //         id={`assignedto-${original.id}`}
    //         value={value?value:props.loggedInUserId } 
    //         onChange={(e) => {
    //           handleTableFieldChange(index, "assigned_to", e.target.value); 
    //         }}
    //         disabled={props.activeTab === "history"}
    //       >
    //         <option value="" disabled={props.activeTab === "history"}>-- Assigned to --</option>
    //         {props.teamMemberList &&
    //           props.teamMemberList.map((member) => (
    //             <option key={member.employeeId} value={member.employeeId}>
    //               {member.employeeName}
    //             </option>
    //           ))}
    //       </select>
    //     );
    //   },
    // },   
    {
      Header: "Priority",
      accessor: "priority",
      // width:100,
      Cell: ({ value }) => (
        <div className='d-flex justify-content-center w-100'>
          {value}
        </div>
      )
    },
    {
      Header: "Created At",
      accessor: "created_at",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Action Required",
      accessor: "alertActionRequired",
      width: 160,
      Cell: (cellInfo) => {
        const rowId = cellInfo.original.id;
        console.log(actionRequiredRows[rowId])
        // Check local state first, fallback to data from props/API
        const currentValue = actionRequiredRows[rowId] !== undefined
          ? actionRequiredRows[rowId]
          : cellInfo.original.alertActionRequired;
    
        const isChecked = currentValue === "Action Required";
        const isDisabled = cellInfo.original.status === "Created"|| props.activeTab === "complete";
    
        return (
          <div className="d-flex justify-content-center w-100">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleActionRequiredToggle(rowId)}
              disabled={isDisabled}
              style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
            />
          </div>
        );
      }
    },
  ];

  return (
    <>
      <Col md={12} className="mt-4">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="m-0">
            <b>TASKS</b>
          </h5>
          <div className="d-flex justify-content-end">
            <Input
              type="text"
              placeholder="Search Tasks..."
              value={searchText}
              onChange={handleSearchChange}
              className={`${props.activeTab === "complete" ? "w-100" : "w-100 mr-4"}`}
            />
            {props.activeTab !== "complete" && (
              <Button
              onClick={handleCreateBulkTasks}
              disabled={selectedAlerts.length === 0 || loading}
              className="btn-background-color-Proceed-gallery hidden-btn w-75"
            >
              {loading
                ? `Creating ${selectedAlerts.length} Tasks...`
                : `Create Task (${selectedAlerts.length})`
              }
            </Button>
            )}
          </div>
        </div>
      </Col>
      <Col md={12}>
        <ReactTable
          data={filteredData}
          columns={columns}
          className="-fixed -highlight -striped mt-2"
          getTheadProps={() => {
            return {
              style: {
                overflowY: "hidden",
                background: "#B1FA63",
                color: "#243837",
              },
            };
          }}
          defaultPageSize={5}
          noDataText={"No Data Found."}
        />
      </Col>
    </>
  );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
});

export default connect(mapStateToProps)(ProactiveMonitoringTasks);
